interface ColoredPillProps {
  text: string;
  textColor: string;
  backgroundColor: string;
  className?: string;
}

const ColoredPill = ({
  text,
  textColor,
  backgroundColor,
  className,
}: ColoredPillProps) => {
  return (
    <div
      className={`px-4 rounded-lg ${backgroundColor} ${textColor} ${
        className ?? ""
      }`}
    >
      <p className="text-small">{text} </p>
    </div>
  );
};

export default ColoredPill;
